var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 511.7,
    height: 37.97,
    viewBox: "0 0 511.7 37.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Zenus_Bank_Turqoise_Primary_RGB",
    transform: "translate(-37.87 -37.87)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Zenus_Bank_RGB_Turqoise"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M237.12,37.9V65.78a3.352,3.352,0,0,1-3.36,3.35h-12.3a3.884,3.884,0,0,1-3.88-3.88V37.89h-9.19V67.08a8.711,8.711,0,0,0,8.71,8.71h20.5a8.711,8.711,0,0,0,8.71-8.71V37.89h-9.19Z",
    fill: "#170a33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M293.94,49.79V48.35a3.879,3.879,0,0,0-3.87-3.87H278.28c-2.1,0-4.35.51-3.73,4.05.96,2.86,3.85,3.2,10.59,4.88,2.93.72,9.17,1.85,12.08,3.46a9.87,9.87,0,0,1,5.35,6.16,14.4,14.4,0,0,1,.5,3.93c0,.22-.02.43-.03.63a8.641,8.641,0,0,1-8.64,8.18H274.45a9.129,9.129,0,0,1-9.12-9.12V63.84h9.14v1.44a3.879,3.879,0,0,0,3.87,3.87h11.79c2.1,0,4.77-.77,3.73-4.05-.96-2.86-3.78-2.62-10.52-4.29-5.66-1.42-9.24-2.43-12.15-4.04h-.02a9.914,9.914,0,0,1-5.34-6.16,14.4,14.4,0,0,1-.5-3.93c0-.22.02-.43.03-.63A8.641,8.641,0,0,1,274,37.87h19.95a9.116,9.116,0,0,1,9.12,9.12V49.8h-9.14Z",
    fill: "#170a33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M94.68,75.79V37.92h37.81v6.64H103.9v8.78h21.96v6.64H103.9v9.19h28.62V75.8H94.68Z",
    fill: "#170a33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M151.47,75.84V37.92h8.63l20.08,23.15V37.92h9.18V75.84h-8.63l-20.08-23.2v23.2Z",
    fill: "#170a33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M454.8,75.84V37.92h8.63l20.08,23.15V37.92h9.18V75.84h-8.63l-20.08-23.2v23.2Z",
    fill: "#170a33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M341,75.84V37.92h22.85q6.48,0,9.85,2.49a8.482,8.482,0,0,1,3.37,7.28,9.294,9.294,0,0,1-1.22,4.74,7.946,7.946,0,0,1-3.47,3.19,8.77,8.77,0,0,1,4.89,3.29,9.585,9.585,0,0,1,1.8,5.84q0,5.445-3.54,8.26T365.1,75.83H341ZM363.05,44.8H350.03v8.53H363q4.995,0,4.99-4.39Q367.99,44.8,363.05,44.8Zm1.2,15.17H350.03v8.98h14.42q5.04,0,5.04-4.49t-5.24-4.49Z",
    fill: "#170a33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M511.63,75.84V37.92h9.98V53.49L536,37.92h12.03L531.96,56.03l17.61,19.81H536.55L521.62,59.57V75.84h-9.98Z",
    fill: "#170a33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M37.87,70.18v5.61H75.75V69.16H38.87Z",
    fill: "#170a33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    d: "M37.88,37.92v6.63H61.69L46.51,60.06H60.57L75.75,44.74V37.92Z",
    fill: "#170a33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    d: "M397.98,46.61V75.8h9.19V59.98h19.54V75.8h9.19V46.61a8.711,8.711,0,0,0-8.71-8.71h-20.5a8.711,8.711,0,0,0-8.71,8.71Zm9.19,6.72V47.91a3.35,3.35,0,0,1,3.35-3.35h12.3a3.884,3.884,0,0,1,3.88,3.88v4.9H407.16Z",
    fill: "#170a33"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.688f9899d577543ac7cd2647fcbe0133.svg";
export { ForwardRef as ReactComponent };